// Centralized hero media configuration (WAIT-4A).
// Swap these paths for final production assets without restructuring the page.
//
// PENDING FINAL MEDIA (must be supplied before launch):
//   * heroVideoSrc  -> /assets/hero.mp4   (promotional background video, currently NOT supplied)
//   * heroPoster    -> /assets/hero-poster.jpg  (TEMPORARY placeholder, replace with final poster)
//
// While heroVideoSrc is null, the hero renders the poster image only (graceful
// fallback). When the final muted/loop/playsInline video is supplied, set
// heroVideoSrc to its path — no component changes required.

export const HERO_MEDIA = {
  // No production video yet. Keep null so only the poster renders.
  videoSrc: null,
  // TEMPORARY placeholder poster (generated dark cinematic still). Replace before launch.
  poster: "/assets/hero-poster.jpg",
  posterIsPlaceholder: true,
};

export const LOGO_SRC = "/assets/corex-logo-white.png";
